import logo from './logo.svg';
import './App.css';
import HomePage from './Pages/HomePage/layout';

function App() {
  return (
    <div className="App">
      <HomePage />

    </div>
  );
}

export default App;
